import React, { useEffect } from "react";
import styles from "./Modal.module.css";
const Modal = ({ show, onClose, iframeSrc }) => {
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  //   if (!show) {
  //     return null;
  //   }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContainer}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <iframe
          src={iframeSrc}
          title="Modal Iframe"
          className={styles.modalIframe}
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Modal;
